/**
 * 环境配置文件
 * 配置不同环境下的API地址等信息
 */

let env = 'development' as EnvType

// 环境类型定义
export type EnvType = 'development' | 'production' | 'test'

// 环境配置接口
export interface EnvConfig {
  // 基础API地址
  baseApi: string
  // API版本
  apiVersion: string
  // 是否使用Mock数据
  useMock: boolean
  // 上传文件地址
  uploadApi: string
  // 静态资源CDN地址
  staticUrl: string
  // 其他额外配置
  [key: string]: any
}

// 开发环境配置
const developmentConfig: EnvConfig = {
  // #ifdef H5
  // baseApi: 'https://miyang-api-test.parkmanage.cn', //'https://parkmanage-test.nbclink.net/desk',
  baseApi: 'https://miyang-api.park-service.cn',
  // #endif
  // #ifndef H5
  // baseApi: 'https://parkmanage-test.nbclink.net/desk',
  // baseApi: 'https://op-pre.parkmanage.cn/desk',
  // baseApi: 'https://miyang-api-test.parkmanage.cn',
  baseApi: 'https://miyang-api.park-service.cn',
  // #endif
  apiVersion: 'v1',
  useMock: true,
  uploadDir: 'u8/upload',
  uploadApi: 'https://miyang-api-test.parkmanage.cn/user/openApi/uploadFile',
  // uploadVideoApi: 'https://miyangjingfu-api-test.nbclink.net/user/openApi/uploadFile',
  staticUrl: 'https://nbcloud-1303036207.cos.ap-guangzhou.myqcloud.com'
}

// 测试环境配置
const testConfig: EnvConfig = {
  baseApi: 'https://miyang-api-test.parkmanage.cn',
  apiVersion: 'v1',
  useMock: false,
  uploadApi: 'http://test-api.example.com/upload',
  staticUrl: 'http://test-static.example.com'
}

// 生产环境配置
const productionConfig: EnvConfig = {
  baseApi: 'https://miyang-api-test.parkmanage.cn',
  apiVersion: 'v1',
  useMock: false,
  uploadApi: 'https://api.example.com/upload',
  staticUrl: 'https://static.example.com'
}

// 所有环境配置映射
const envConfigMap: Record<EnvType, EnvConfig> = {
  development: developmentConfig,
  test: testConfig,
  production: productionConfig
}

/**
 * 获取当前环境配置
 * @returns 环境配置
 */
export function getEnvConfig(): EnvConfig {
  // 获取当前环境
  // 优先使用自定义环境变量VITE_APP_ENV，如果没有则使用NODE_ENV
  //   let env = (import.meta.env.VITE_APP_ENV || import.meta.env.MODE) as EnvType;

  // 确保环境值有效
  if (!envConfigMap[env]) {
    console.warn(`未找到环境 ${env} 的配置，将使用开发环境配置`)
    env = 'development'
  }

  return envConfigMap[env]
}

// 默认导出当前环境配置
export default getEnvConfig()
